var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat-feed-provider',{attrs:{"feed":_vm.feed}},[_c('wds-chat-audio',{ref:"messageAudio",attrs:{"url":"https://back.files.design/media/1586"}}),_vm._t("default",null,{"feed":_vm.feed,"chatsCount":_vm.counter.count,"chatId":_vm.chatId})],2)}
var staticRenderFns = []

export { render, staticRenderFns }